import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBusDetailsAction } from "../../actions/trip-create.actions";
import { tripCreateReducerSelector } from "../../selector/trip-create.selector";
import { Button, Modal, Select, message,Row,Col, Radio, Checkbox } from "antd";
import { getSeatLayOut } from "../../actions/admin.action";
import './change-seat-layout.style.scss';
import { SeatLayoutContainer } from "../seat-layout/seat-layout-container.component";
import { changeSeatLayoutReq } from "./change-seat-layout.module";
import { loadingAction } from "../../actions/loading-actions";
import { showConfirm } from "../custom-components/custom-component";
import { isValid, getValuesOfJSonObject, isValidArrayWithValues } from "../../utils/utilities";
import { fetchSeatLayout } from "../../actions/home.action";
import { passengerInfoSelector } from "../../selector/passenger-form.selector";
import { resetPassengerForm } from "../../actions/ticket.action";
import { getVechicles } from "../edit-vechicle-component/edit-vechicle.module";

// const {
//     Option
// } = Select;

// const printBusesOption = (option) => {
//     return <Option  value={option.id} data={option} key={option.description}>{option.description}</Option>
// };

export const ChangeSeatLayout = (props) => {
    const{
        tripId,
        tripRouteId,
        isSchedule = false,
        scheduleBusId = null,
        scheduleParams = null
    }=props;

    const [isModalVisible,setModalVisible] = useState(false);
    const [seatLayoutData,setSeatLayoutData] = useState([]);
    const [busId,setBusId] = useState(null);
    const [currentSeatLayoutData,setCurrentSeatLayoutData] = useState([]);
    const [layoutMapping, setLayoutMapping] = useState({});
    const [oldLayoutNoSeats, setOldLayoutNoSeats] = useState(1);
    const [reservedSeats, setReservedSeats] = useState({});
    const [oldSelectedSeats, setOldSelectedSeats] = useState([]);
    const [busesOptions, setBusesOptions] = useState([]);
    const [vechicleOptions, setVechicleOptions] = useState([]);
    const [vechicles, setVechicles] = useState([]);
    const [selectedBusOption, setSelectedBusOption] = useState(null);
    const [selectedVechicleOption, setSelectedVechicleOption] = useState(null);
    const [selectType, setSelectType] = useState('bus');
    // Ref (not state) because the checkbox lives inside Modal.confirm content,
    // which does not re-render on state changes. Same behaviour as the
    // modify/cancel page's bus change Send Notification checkbox.
    const sendNotificationRef = useRef(true);

    const dispatch = useDispatch();

    const handleOk=()=>{
       
    }
    const {
        selectedSeats
    } = useSelector(passengerInfoSelector);

    const handleCancel=()=>{
        setModalVisible(false);
    }

    useEffect(() => {
        if (isValid(selectedSeats)) {
            let seatsArray=getValuesOfJSonObject(selectedSeats);
            let seatLength = seatsArray.length;
            let oldSeat, newSeat, gender, seatStatus;
            if (seatLength==1) {
                setOldLayoutNoSeats(0);
            }
            else if (seatLength>1) {
                seatsArray.map((seat)=> {
                    if(["Confirmed","Blocked"].includes(seat.seatStatus)) {
                        oldSeat = seat.seatNumber;
                        gender = seat.gender;
                        seatStatus = seat.seatStatus;
                    }
                    else {
                        newSeat = seat.seatNumber;
                    }
                })
                let tempLayoutMapping = layoutMapping;
                if (isValid(oldSeat)&&isValid(newSeat)) {
                    tempLayoutMapping[oldSeat] = newSeat;
                    setLayoutMapping(tempLayoutMapping);
                    formatNewSeatLayout(oldSeat, newSeat, gender, seatStatus, false);
                    setOldSelectedSeats(Object.keys(tempLayoutMapping));
                }
                dispatch(resetPassengerForm());
                setOldLayoutNoSeats(1);
            }
        }
    }, [selectedSeats])

    const loadCurrentSeatLayout = () => {
        if (isValid(tripRouteId)) {
            dispatch(fetchSeatLayout(tripRouteId,(seatsData)=>{
                setCurrentSeatLayoutData(seatsData.seats);
                let tempReserved = {};
                seatsData.seats.map((seat) => {
                    if (["Confirmed","Blocked"].includes(seat.seat_status)) {
                        tempReserved[seat.seat_number]= seat;
                    }
                })
                setReservedSeats(tempReserved);
            },()=>{}));
        }
    }

    useEffect(() => {
        loadCurrentSeatLayout();
    },[tripRouteId])

    useEffect(()=>{
        if(isValid(scheduleBusId)){
            getSeatLayOut(scheduleBusId,(data)=> {
                setCurrentSeatLayoutData(data.seat_layout);
            },()=>{});
        }
    },[scheduleBusId])
    
    useEffect(()=>{
        dispatch(getBusDetailsAction());
    },[]);

    useEffect(() => {
        getVechicles((data) => {
            setVechicles(isValidArrayWithValues(data) ? data : []);
        });
    }, []);

    const formatNewSeatLayout = (oldSeat, newSeat, gender, seatStatus, isReset=false) => {
        let tempSeatLayout = [...seatLayoutData];
        let prevSeat = `(${oldSeat})`
        let assignSeatNum = newSeat+prevSeat;
        tempSeatLayout.map((seat) => {
            let seatNum = seat.seat_number;
            let originalNum = seat.original_seat_number;
            if (!isReset) {
                if (seatNum.includes(prevSeat)&&originalNum!=newSeat) {
                    seat.seat_number = originalNum;
                    seat.gender = null;
                    seat.seat_status = '';
                    seat.blocked_by = '';
                    seat.full_name = '';
                    seat.phone_number = '';
                    seat.seat_status_class_name = '';
                    seat.seat_status_color = null;
                    if(isValid(seat.passengers)) {
                        delete seat.passengers;
                    }
                }
                if (originalNum==newSeat) {
                    let oldSeatData = reservedSeats[oldSeat];
                    seat.seat_number = assignSeatNum;
                    seat.gender = gender;
                    seat.seat_status = seatStatus;
                    seat.blocked_by = oldSeatData.blocked_by;
                    seat.full_name = oldSeatData.full_name;
                    seat.phone_number = oldSeatData.phone_number;
                    seat.seat_status_class_name = oldSeatData.seat_status_class_name;
                    seat.seat_status_color = oldSeatData.seat_status_color;
                    if(isValid(oldSeatData.passengers)) {
                        seat.passengers = oldSeatData.passengers;
                    }
                    seat.ticket_id = oldSeatData.ticket_id;
                    seat.ticket_agent_privilege = oldSeatData.ticket_agent_privilege;
                }
            }
            else {
                seat.seat_number = originalNum;
                seat.gender = null;
                seat.seat_status = '';
                seat.blocked_by = '';
                seat.full_name = '';
                seat.phone_number = '';
                seat.seat_status_class_name = '';
                seat.seat_status_color = null;
                if(isValid(seat.passengers)) {
                    delete seat.passengers;
                }
            }
        })
        setSeatLayoutData(tempSeatLayout);
    }

    const setLoading=(val)=>{
        dispatch(loadingAction(val));
    }

    const tripCreateReducer = useSelector(tripCreateReducerSelector);
    let { busesData } = tripCreateReducer;

    const onSuccess=(data)=>{
        let fetchedSeatLayout = [...data.seat_layout];
        fetchedSeatLayout.map((seat) => {
            seat.original_seat_number = seat.seat_number;
        })
        setSeatLayoutData(fetchedSeatLayout);
    }

    const loadSeatLayoutByBusId = (selectedBusId) => {
        setBusId(selectedBusId);
        setSeatLayoutData([]);
        getSeatLayOut(selectedBusId,onSuccess,onFailure);
    }

    useEffect(()=>{
        if(isValid(busesData)){
            let tempBusesOptions = [];
            busesData.map((bus)=>{
                tempBusesOptions.push({value: bus.id, label: bus.description});
            })
            setBusesOptions(tempBusesOptions);
        }
    },[busesData, vechicles]);

    useEffect(() => {
        let tempVechicleOptions = [];
        vechicles.map((vechicle) => {
            if (isValid(vechicle.vechicle_no) && isValid(vechicle.bus_id)) {
                tempVechicleOptions.push({
                    value: vechicle.id,
                    label: vechicle.vechicle_no,
                    bus_id: vechicle.bus_id
                });
            }
        });
        setVechicleOptions(tempVechicleOptions);
    }, [vechicles]);

    const onFailure=()=>{

    }

    const handleReset=()=>{
        let tempOldSeatLayout = [...currentSeatLayoutData];
        setCurrentSeatLayoutData([]);
        formatNewSeatLayout(null,null,null,null,true);
        dispatch(resetPassengerForm());
        setOldSelectedSeats([]);
        setLayoutMapping({});
        setOldLayoutNoSeats(1);
        setCurrentSeatLayoutData(tempOldSeatLayout);
    }    

    // Only the {oldSeat: newSeat} mapping goes to the server - it rebuilds the seat
    // data from its own tables and validates there against live data (occupancy,
    // target seats, gender adjacency). The checks here are just instant feedback
    // for mistakes the mapping itself shows.
    const validateSeatLayout=()=>{
        let oldReservedSeats = Object.keys(reservedSeats), mappedReservedSeats = Object.keys(layoutMapping);
        if (oldReservedSeats.length == mappedReservedSeats.length) {
            let dupSeat = [], newSeatsList =[];
            mappedReservedSeats.map((seat) => {
                let newSeat = layoutMapping[seat];
                if (newSeatsList.includes(newSeat)&&!dupSeat.includes(newSeat)) {
                    dupSeat.push(newSeat);
                }
                newSeatsList.push(newSeat);
            })
            if (dupSeat.length==0) {
                return ({status:true,message:"Seat Layout Changed succuessfully!", seatMapping:{...layoutMapping}})
            }
            else {
                return ({status:false,message:`Seat numbers ${dupSeat} is mapped for more than one seat.`})
            }
        }
        else {
            let leftSeats = oldReservedSeats.filter((seat)=> !mappedReservedSeats.includes(seat));
            let msg = `Kindly map seat numbers ${leftSeats} from old layout to new layout.`;
            return ({status:false,message:msg})
        }
    }

    const renderModalContent = () => (
        <div>
            <Row gutter={[16, 16]} className="marginBottom">
                <Col xs={24} sm={24} md={11}>
                    <Radio.Group
                        value={selectType}
                        onChange={(e) => {
                            const nextType = e.target.value;
                            setSelectType(nextType);
                            setSelectedBusOption(null);
                            setSelectedVechicleOption(null);
                            setBusId(null);
                            setSeatLayoutData([]);
                        }}
                    >
                        <Radio value="bus">Seat Layout</Radio>
                        <Radio value="vechicle">Vehicle Number</Radio>
                    </Radio.Group>
                </Col>
                {selectType === 'bus' && (
                    <Col xs={24} sm={24} md={11}>
                        <Select
                            showSearch
                            className="changeBusSelect"
                            placeholder="Select bus"
                            style={{ width: '100%' }}
                            value={selectedBusOption}
                            onChange={(value)=>{
                                setSelectedBusOption(value);
                                setSelectedVechicleOption(null);
                                loadSeatLayoutByBusId(value);
                            }}
                            filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            options={busesOptions}
                        />
                    </Col>
                )}

                {selectType === 'vechicle' && (
                    <Col xs={24} sm={24} md={11}>
                        <Select
                            showSearch
                            className="changeBusSelect"
                            placeholder="Select vechicle"
                            style={{ width: '100%' }}
                            value={selectedVechicleOption}
                            onChange={(value, option)=>{
                                setSelectedVechicleOption(value);
                                setSelectedBusOption(option?.bus_id || null);
                                if (isValid(option?.bus_id)) {
                                    loadSeatLayoutByBusId(option.bus_id);
                                }
                            }}
                            filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            options={vechicleOptions}
                        />
                    </Col>
                )}
            </Row>
            <Row gutter={[24, 24]}>
                <Col xs={24} sm={24} md={11}>
                    <div className="layout-section">
                        <span style={{fontWeight:'bold'}}>Current Layout</span>
                        <div className="seat-container">
                            <SeatLayoutContainer
                                seatsData={currentSeatLayoutData}
                                showLegend={false}
                                showFarePopOver={false}
                                blockedSeatAllowed={true}
                                noOfSeatsAllowedToClick={oldLayoutNoSeats}
                                changeOldLayout={true}
                                oldSelectedSeats={oldSelectedSeats}
                                isDragDropRequired={false}
                                skipBlockedGroupValidation={true}
                            />
                        </div>
                    </div>
                </Col>
                <Col xs={24} sm={24} md={11}>
                    <div className="layout-section">
                        <span style={{fontWeight:'bold'}}>New Layout</span>
                        <div className="seat-container">
                            <SeatLayoutContainer
                                seatsData={seatLayoutData}
                                showLegend={false}
                                showFarePopOver={false}
                                blockedSeatAllowed={false}
                                noOfSeatsAllowedToClick={oldLayoutNoSeats==0?2:0}
                                isDragDropRequired={false}
                                skipBlockedGroupValidation={true}
                            />
                        </div>
                    </div>
                </Col>
            </Row>

            {seatLayoutData.length>0 && (
                <>
                {!isSchedule && <Row justify="center" style={{ marginTop: 16 }}>
                    <Col>
                        <Button
                            style={{ marginRight: 8 }}
                            onClick={() => {
                                let tempLayoutMapping = {};
                                Object.keys(reservedSeats).forEach(oldSeat => {
                                    // Find matching seat by row, column and deck in new layout
                                    const oldSeatData = reservedSeats[oldSeat];
                                    const matchingSeat = seatLayoutData.find(
                                        seat => seat.seat_row_number === oldSeatData.seat_row_number &&
                                               seat.seat_column_number === oldSeatData.seat_column_number &&
                                               seat.upper_deck === oldSeatData.upper_deck
                                    );

                                    if (matchingSeat) {
                                        tempLayoutMapping[oldSeat] = matchingSeat.original_seat_number;
                                        formatNewSeatLayout(
                                            oldSeat,
                                            matchingSeat.original_seat_number,
                                            oldSeatData.gender,
                                            oldSeatData.seat_status,
                                            false
                                        );
                                    }
                                });
                                let tempOldSeatLayout = [...currentSeatLayoutData];
                                setCurrentSeatLayoutData([]);
                                setCurrentSeatLayoutData(tempOldSeatLayout);
                                setLayoutMapping(tempLayoutMapping);
                                setOldSelectedSeats(Object.keys(tempLayoutMapping));

                                if (Object.keys(tempLayoutMapping).length > 0) {
                                    message.success(`${Object.keys(tempLayoutMapping).length} seats mapped successfully!`);
                                } else {
                                    message.error("No matching seats found based on position.");
                                }
                            }}
                        >
                            Positional Transfer
                        </Button>
                        <Button
                            style={{ marginRight: 8 }}
                            onClick={() => {
                                let tempLayoutMapping = {};
                                Object.keys(reservedSeats).forEach(oldSeat => {
                                    // Find matching seat number in new layout
                                    const matchingSeat = seatLayoutData.find(
                                        seat => seat.original_seat_number === oldSeat
                                    );
                                    if (matchingSeat) {
                                        tempLayoutMapping[oldSeat] = matchingSeat.original_seat_number;
                                        formatNewSeatLayout(
                                            oldSeat,
                                            matchingSeat.original_seat_number,
                                            reservedSeats[oldSeat].gender,
                                            reservedSeats[oldSeat].seat_status,
                                            false
                                        );
                                    }
                                });
                                let tempOldSeatLayout = [...currentSeatLayoutData];
                                setCurrentSeatLayoutData([]);
                                setCurrentSeatLayoutData(tempOldSeatLayout);
                                setLayoutMapping(tempLayoutMapping);
                                setOldSelectedSeats(Object.keys(tempLayoutMapping));

                                if (Object.keys(tempLayoutMapping).length > 0) {
                                    message.success(`${Object.keys(tempLayoutMapping).length} seats mapped successfully!`);
                                } else {
                                    message.error("Seat numbers don't match between layouts.");
                                }
                            }}
                        >
                            Auto Map Seats
                        </Button>
                    </Col>
                    <Col>
                        <Button
                            style={{ marginRight: 8 }}
                            onClick={handleReset}
                        >
                            Reset
                        </Button>
                    </Col>
                </Row>}
                <Row justify="center" style={{ marginTop: 16 }}>
                    <Col>
                        <Button
                            style={{ marginRight: 8 }}
                            onClick={handleCancel}
                            className="exit-btn"
                        >
                            Cancel
                        </Button>
                        <Button
                            style={{ marginRight: 8 }}
                            disabled={isSchedule && !scheduleParams?.isPermanent && scheduleParams.selectedTripIds.length==0 ? true : false}
                            onClick={()=>{
                                if (!isSchedule) {
                                    let validateSeatLayoutData = validateSeatLayout();
                                    if(validateSeatLayoutData.status){
                                        showConfirm(()=>{
                                            setLoading(true);
                                            changeSeatLayoutReq(tripId,busId,validateSeatLayoutData.seatMapping,{},sendNotificationRef.current,(responseData)=>{
                                                setLoading(false);
                                                dispatch(resetPassengerForm());
                                                setOldLayoutNoSeats(0);
                                                setSeatLayoutData([]);
                                                // The trip is on the new bus now - drop the mapping and
                                                // re-fetch the current layout so reopening the modal does
                                                // not offer the pre-change seats for another transfer.
                                                setLayoutMapping({});
                                                setOldSelectedSeats([]);
                                                loadCurrentSeatLayout();
                                                handleCancel();
                                                message.success("Seat Layout Changed succuessfully!");

                                            },(err)=>{
                                                message.error(err);
                                                setLoading(false);
                                            });
                                        },"Are you sure to change seat layout?",
                                        <Checkbox
                                            defaultChecked={sendNotificationRef.current}
                                            onChange={(e)=>{sendNotificationRef.current = e.target.checked}}
                                        >
                                            Send Notification
                                        </Checkbox>);
                                    }
                                    else{
                                        message.error(validateSeatLayoutData.message);
                                    }
                                }
                                else{
                                    changeSeatLayoutReq(null,busId,null,scheduleParams,false,(responseData)=>{
                                        handleCancel();
                                        if (isValid(responseData) && isValidArrayWithValues(responseData.failedLayoutDates)) {
                                            message.error("Ticket exists for following dates. Kindly change layout trip wise for dates " + responseData.failedLayoutDates.join(", "));
                                        }
                                        message.success("Seat Layout Changed succuessfully!");
                                    },(err)=>{
                                        message.error(err);
                                    });
                                }
                            }}
                        >
                            Change Layout
                        </Button>
                    </Col>
                </Row>
                </>
            )}
        </div>
    );

    if (!isSchedule) {
        return (
            <div className="">
                <Button
                    className="bordered-btn send-driver-details-btn"
                    onClick={()=>{
                        setModalVisible(true);
                    }}
                >
                    Change Layout
                </Button>
                <Modal
                    title={"Change Seat Layout"}
                    visible={isModalVisible}
                    onCancel={handleCancel}
                    width="95%"
                    style={{ maxWidth: 1200 }}
                    footer={null}
                >
                    {renderModalContent()}
                </Modal>
            </div>
        );
    }

    return renderModalContent();
}
